var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg08Battery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    width: 239.175,
    height: 164.248,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st874{fill:#ecf1ff}.st875{fill:#c1c6db}.st876{fill:#556c93}.st878{fill:#ff0002}.st879{fill:#c1292d}.st880{fill:#15273f}.st881{opacity:.1;fill:#0a0f15}.st882{fill:#0a0f15;fill-opacity:.25}")), /*#__PURE__*/React.createElement("path", {
    d: "M226.423 125.358c9.007-18.482-24.331-37.146-9.531-51.914 17.556-17.52 34.409-45.365 10.272-59.809-20.839-12.47-36.102 12.245-54.755 2.52-9.713-5.066-23.408-29.048-43.286-6.954-9.97 11.082-15.182 13.432-14.641 27.221 1.056 26.886 23.159 28.057 36.656 46.037 12.43 16.558-3.207 48.647 18.058 61.017 20.644 12.01 46.748 3.386 57.227-18.118z",
    id: "path1801",
    style: {
      fill: "#ecf0f1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1981",
    transform: "translate(-1649.093 -1069.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1825"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st874",
    id: "rect1803",
    d: "M1649.093 1126.069h48.961v103.73h-48.961z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1703.032 1177.934)",
    className: "st875",
    id: "rect1805",
    d: "M1698.054 1126.069h9.956v103.73h-9.956z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st875",
    id: "rect1807",
    d: "M1654.228 1138.501h38.691v78.866h-38.691z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st876",
    id: "rect1809",
    d: "M1654.228 1167.654h10.829v20.561h-10.829z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon1811",
    style: {
      fill: "#a0a3b7"
    },
    d: "M1654.228 1138.501v78.866h1.932v-76.806h36.759v-2.06h-37.247z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st878",
    id: "rect1813",
    d: "M1651.178 1122.227h44.791v3.842h-44.791z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1700.674 1124.148)",
    className: "st879",
    id: "rect1815",
    d: "M1695.969 1122.227h9.409v3.842h-9.409z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st880",
    id: "rect1817",
    d: "M1651.178 1229.799h44.791v3.842h-44.791z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1700.674 1231.72)",
    id: "rect1819",
    d: "M1695.969 1229.799h9.409v3.842h-9.409z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st881",
    id: "polygon1821",
    d: "M1698.054 1229.799v-103.73l-48.961 103.73z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st878",
    id: "polygon1823",
    d: "m1676.644 1145.501-8.687 11.632h4.878l-1.933 10.064 8.23-12.622h-4.877z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1879"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st874",
    id: "rect1827",
    d: "M1704.553 1108.998h46.522v120.801h-46.522z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1754.834 1169.399)",
    className: "st875",
    id: "rect1829",
    d: "M1751.076 1108.998h7.518v120.801h-7.518z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st876",
    id: "rect1831",
    d: "M1709.688 1121.43h36.252v95.937h-36.252z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st880",
    id: "rect1833",
    d: "M1709.688 1121.43h1.444v95.937h-1.444z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st880",
    id: "rect1835",
    d: "M1709.688 1121.43h36.252v2.06h-36.252z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1867"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1837",
    d: "M1713.657 1132.33h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1839",
    d: "M1713.657 1137.874h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1841",
    d: "M1713.657 1143.418h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1843",
    d: "M1713.657 1148.962h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1845",
    d: "M1713.657 1154.506h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1847",
    d: "M1713.657 1160.05h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1849",
    d: "M1713.657 1165.594h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1851",
    d: "M1713.657 1171.138h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1853",
    d: "M1713.657 1176.681h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1855",
    d: "M1713.657 1182.225h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1857",
    d: "M1713.657 1187.769h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1859",
    d: "M1713.657 1193.313h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1861",
    d: "M1713.657 1198.857h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1863",
    d: "M1713.657 1204.401h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1865",
    d: "M1713.657 1209.945h30.546v2.06h-30.546z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st878",
    id: "rect1869",
    d: "M1706.638 1105.156h42.352v3.842h-42.352z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1752.476 1107.077)",
    className: "st879",
    id: "rect1871",
    d: "M1748.991 1105.156h6.971v3.842h-6.971z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st880",
    id: "rect1873",
    d: "M1706.638 1229.799h42.352v3.842h-42.352z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1752.476 1231.72)",
    id: "rect1875",
    d: "M1748.991 1229.799h6.971v3.842h-6.971z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st881",
    id: "polygon1877",
    d: "M1751.076 1229.799v-120.801l-46.523 120.801z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g1933"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1832.739 1169.399)",
    className: "st874",
    id: "rect1881",
    d: "M1809.478 1108.998H1856v120.801h-46.522z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st875",
    id: "rect1883",
    d: "M1801.96 1108.998h7.518v120.801h-7.518z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1832.739 1169.399)",
    className: "st876",
    id: "rect1885",
    d: "M1814.613 1121.43h36.252v95.937h-36.252z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1850.143 1169.399)",
    className: "st880",
    id: "rect1887",
    d: "M1849.421 1121.43h1.444v95.937h-1.444z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1832.739 1122.46)",
    className: "st880",
    id: "rect1889",
    d: "M1814.613 1121.43h36.252v2.06h-36.252z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1921"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1831.624 1133.36)",
    className: "st882",
    id: "rect1891",
    d: "M1816.351 1132.33h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1831.624 1138.904)",
    className: "st882",
    id: "rect1893",
    d: "M1816.351 1137.874h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1831.624 1144.448)",
    className: "st882",
    id: "rect1895",
    d: "M1816.351 1143.418h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1831.624 1149.992)",
    className: "st882",
    id: "rect1897",
    d: "M1816.351 1148.962h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1831.624 1155.536)",
    className: "st882",
    id: "rect1899",
    d: "M1816.351 1154.506h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1831.624 1161.08)",
    className: "st882",
    id: "rect1901",
    d: "M1816.351 1160.05h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1831.624 1166.624)",
    className: "st882",
    id: "rect1903",
    d: "M1816.351 1165.594h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1831.624 1172.168)",
    className: "st882",
    id: "rect1905",
    d: "M1816.351 1171.138h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1831.624 1177.711)",
    className: "st882",
    id: "rect1907",
    d: "M1816.351 1176.681h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1831.624 1183.255)",
    className: "st882",
    id: "rect1909",
    d: "M1816.351 1182.225h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1831.624 1188.8)",
    className: "st882",
    id: "rect1911",
    d: "M1816.351 1187.769h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1831.624 1194.343)",
    className: "st882",
    id: "rect1913",
    d: "M1816.351 1193.313h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1831.624 1199.887)",
    className: "st882",
    id: "rect1915",
    d: "M1816.351 1198.857h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1831.624 1205.43)",
    className: "st882",
    id: "rect1917",
    d: "M1816.351 1204.401h30.546v2.06h-30.546z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1831.624 1210.975)",
    className: "st882",
    id: "rect1919",
    d: "M1816.351 1209.945h30.546v2.06h-30.546z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1832.739 1107.077)",
    className: "st878",
    id: "rect1923",
    d: "M1811.563 1105.156h42.352v3.842h-42.352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st879",
    id: "rect1925",
    d: "M1804.592 1105.156h6.971v3.842h-6.971z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 1832.739 1231.72)",
    className: "st880",
    id: "rect1927",
    d: "M1811.563 1229.799h42.352v3.842h-42.352z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1929",
    d: "M1804.592 1229.799h6.971v3.842h-6.971z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st881",
    id: "polygon1931",
    d: "M1856 1229.799v-120.801l-46.522 120.801z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g1979"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st874",
    id: "rect1935",
    d: "M1757.876 1108.998h46.522v120.801h-46.522z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st876",
    id: "rect1937",
    d: "M1763.011 1121.43h36.252v95.937h-36.252z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st880",
    id: "rect1939",
    d: "M1763.011 1121.43h36.252v2.06h-36.252z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1971"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1941",
    d: "M1764.749 1132.33h32.776v2.06h-32.776z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1943",
    d: "M1764.749 1137.874h32.776v2.06h-32.776z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1945",
    d: "M1764.749 1143.418h32.776v2.06h-32.776z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1947",
    d: "M1764.749 1148.962h32.776v2.06h-32.776z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1949",
    d: "M1764.749 1154.506h32.776v2.06h-32.776z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1951",
    d: "M1764.749 1160.05h32.776v2.06h-32.776z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1953",
    d: "M1764.749 1165.594h32.776v2.06h-32.776z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1955",
    d: "M1764.749 1171.138h32.776v2.06h-32.776z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1957",
    d: "M1764.749 1176.681h32.776v2.06h-32.776z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1959",
    d: "M1764.749 1182.225h32.776v2.06h-32.776z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1961",
    d: "M1764.749 1187.769h32.776v2.06h-32.776z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1963",
    d: "M1764.749 1193.313h32.776v2.06h-32.776z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1965",
    d: "M1764.749 1198.857h32.776v2.06h-32.776z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1967",
    d: "M1764.749 1204.401h32.776v2.06h-32.776z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st882",
    id: "rect1969",
    d: "M1764.749 1209.945h32.776v2.06h-32.776z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st880",
    id: "rect1973",
    d: "M1759.961 1229.799h42.352v3.842h-42.352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st878",
    id: "rect1975",
    d: "M1759.961 1105.156h42.352v3.842h-42.352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st881",
    id: "polygon1977",
    d: "M1804.399 1229.799v-120.801l-46.523 120.801z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg08Battery);
export default __webpack_public_path__ + "static/media/08-Battery.de4c0dcdabfd1d732214bd2f7dc114ac.svg";
export { ForwardRef as ReactComponent };